import { render, staticRenderFns } from "./NewPassword-comp.vue?vue&type=template&id=5935f1e1&scoped=true&"
import script from "./NewPassword-comp.vue?vue&type=script&lang=js&"
export * from "./NewPassword-comp.vue?vue&type=script&lang=js&"
import style0 from "./NewPassword-comp.vue?vue&type=style&index=0&id=5935f1e1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5935f1e1",
  null
  
)

export default component.exports